import React from 'react';
import { RACHIT_CONFIG } from '../../configs/rachit.config';
import QuizGame from './QuizGame';

export default function RachitQuiz() {
  return <QuizGame config={RACHIT_CONFIG} />;
}
